import { useEffect, useRef } from 'react';

import { SPACE_LIST_ID } from '../constants/space-list-id.constant';
import type { Space } from '../enums/space.enum';

// Scrolls the main menu to the space of the current page whenever the page
// changes of space (or its space shows up, like the one of a sub-mission once
// loaded), the space then starting right under the toolbar of the menu.
export const useScrollToCurrentSpace = (
  currentSpace: Space | undefined,
  isCurrentSpaceShown: boolean,
) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const toolbarRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    const spaceList =
      currentSpace && isCurrentSpaceShown
        ? container?.querySelector<HTMLElement>(
            `#${SPACE_LIST_ID[currentSpace]}`,
          )
        : null;

    if (!container || !spaceList) {
      return;
    }

    container.scrollTo({
      behavior: 'smooth',
      top: spaceList.offsetTop - (toolbarRef.current?.offsetHeight ?? 0),
    });
  }, [currentSpace, isCurrentSpaceShown]);

  return { containerRef, toolbarRef };
};
